export const YEARS_DEFAULT = "All time";
export const TOPICS_DEFAULT = "All stuff";
